import { TextField } from '@mui/material';
import { getIn } from 'formik';
import isEqual from 'lodash/isEqual';
import { func, object } from 'prop-types';
import React, { memo, useCallback } from 'react';

const FormikTextField = ({ field, bindChange = () => {}, form, onBlur: onBlurProp, ...props }) => {
  const { name, value, onChange, onBlur } = field;
  const { submitCount } = form;
  // Use getIn to properly access nested errors (e.g., configuration.driveId)
  let error = getIn(form.errors, name);
  if (error?.length === 1) {
    // Bug when a ListField has a global, this shows the first character of it
    error = null;
  }
  const handleBlur = useCallback(
    e => {
      onBlur(e);
      if (onBlurProp) {
        onBlurProp(e);
      }
    },
    [onBlur, onBlurProp],
  );
  const handleChange = useCallback(
    e => {
      bindChange(e);
      onChange(e);
    },
    [bindChange, onChange],
  );
  return (
    <TextField
      fullWidth
      {...props}
      onChange={handleChange}
      onBlur={handleBlur}
      value={value}
      name={name}
      error={!!(error && submitCount > 0)}
      helperText={submitCount > 0 && error}
    />
  );
};

FormikTextField.propTypes = {
  field: object.isRequired,
  form: object.isRequired,
  bindChange: func,
  onBlur: func,
};

const areEqual = (
  { form: { submitCount, errors }, field: { name, value }, type, disabled, InputProps, slotProps },
  {
    form: { submitCount: newSubmitCount, errors: nextErrors },
    field: { value: nextValue },
    type: nextType,
    disabled: nextDisabled,
    InputProps: nextInputProps,
    slotProps: nextSlotProps,
  },
) => {
  return (
    submitCount === newSubmitCount &&
    value === nextValue &&
    getIn(errors, name) === getIn(nextErrors, name) &&
    type === nextType &&
    disabled === nextDisabled &&
    isEqual(InputProps, nextInputProps) &&
    isEqual(slotProps, nextSlotProps)
  );
};

export default memo(FormikTextField, areEqual);
